<template>
  <div class="white lighten-4">
    <v-container style="max-width: 1800px" class="py-0">
      <v-toolbar elevation="0" class="white">
        <v-toolbar-items>
           <v-btn
            link
            text
            :to="`/project/${projectId}/settings/info`"
            >{{ $t('project.project_information') }}</v-btn
          >
          <v-btn
            link
            text
            :to="`/project/${projectId}/settings/accountingprodcut`"
            >{{ $t('bill.bill_list') }}</v-btn
          >
          <!-- <v-btn
            link
            text
            :to="`/project/${projectId}/settings/accountings`"
            >ผังบัญชี</v-btn
          > -->
          <v-btn text link :to="`/project/${projectId}/settings/bankaccount`"
            >{{ $t('payment.bank_account') }}</v-btn
          >
          <v-btn text link :to="`/project/${projectId}/settings/product`"
            >{{ $t('product.title') }}</v-btn
          >
          <v-btn text link :to="`/project/${projectId}/settings/asset`"
            >{{ $t('asset.title') }}</v-btn
          >
          <v-btn text link :to="`/project/${projectId}/settings/personnel`"
            >{{ $t('project.personnel') }}</v-btn
          >
          <v-btn text link :to="`/project/${projectId}/settings/documenttemplate`"
            >{{ $t('project.document_template') }}</v-btn
          >
          <v-btn text link :to="`/project/${projectId}/settings/settingplan`"
            v-if="project.layoutType == 1"
            >{{ $t('project.plan', { name: '' }) }}</v-btn
          >
        </v-toolbar-items>
      </v-toolbar>
    </v-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      projectId: this.$route.params.projectId,
      project: null
    };
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
  },
  created(){
    this.project = this.admins[0].project
  }
};
</script>

<style lang="scss" scoped>
.v-btn--text {
  color: #888 !important;
}
.v-btn--active {
  color: #000 !important;
  background-color: white !important;
  border-bottom: 3px solid #00a650;
}
.v-btn:before {
  background-color: white !important;
}
.v-btn {
  padding: 1rem;
}
</style>
